angular.
module("digiexam.services").
factory("dxExam", function ExamFactory(
	$http,

	DxAnswer,
	Exam
) {
	"use strict";

	function copy(examId, courseId, groupId) {
		return $http.post("/exam/copy/", {
			examId: examId,
			courseId: courseId,
			groupId: groupId,
		}).then(function success(response) {
			return response.data;
		});
	}

	function setFlags(studentId, examId, flags) {
		return $http.post("/exam/setflags/", {
			studentId: parseInt(studentId, 10),
			examId: parseInt(examId, 10),
			flags: flags,
		}).then(function success(response) {
			return response.data;
		});
	}

	function report(examId, studentId) {
		return $http.get("/student/" + studentId + "/exams/" + examId).then(function success(response) {
			if (response.data) {
				response.data = new Exam(response.data);
			}

			if (response.data.settings !== null &&
				response.data.settings.student !== null &&
				response.data.settings.student.answers) {
				for (var i = 0; i < response.data.settings.student.answers.length; i++) {
					var a = response.data.settings.student.answers[i];
					response.data.settings.student.answers[i] = new DxAnswer(a);
				}
			}

			return response.data;
		});
	}
	function getPublicInfo(examId) {
		return $http.get("/exam/" + examId + "/publicinfo").then(function success(response) {
			return response.data;
		});
	}
	function getSettings(examId, studentId) {
		return $http.get("/exam/" + examId + "/settings/" + studentId).then(function success(response) {
			return response.data;
		});
	}
	return {
		copy: copy,
		setFlags: setFlags,
		report: report,
		getPublicInfo: getPublicInfo,
		getSettings: getSettings,
	};
});
